import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { Icon } from '../Icon';
import { NumberLabel } from '../Labels';
import { CardInfo, CardText, CardTitle, CardSubTitle, Tagline } from './partials';
export var TagInfo = function TagInfo(_ref) {
  var entity = _ref.entity;
  var name = entity.name,
    alias = entity.alias,
    icon = entity.icon,
    tagline = entity.tagline,
    followers = entity.followers;
  var entityURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com', "/temas/").concat(alias);
  var upperName = "".concat(name.charAt(0).toUpperCase()).concat(name.slice(1));
  return React.createElement(CardInfo, null, React.createElement(Icon, {
    type: "tag",
    size: 3,
    alt: upperName,
    image: icon ? icon.includes('image') ? icon : "/image/".concat(icon) : null,
    margin: "0 18px 0 0",
    url: entityURL
  }), React.createElement(CardText, {
    centered: !tagline
  }, React.createElement(CardTitle, {
    href: entityURL
  }, upperName), Number.isInteger(followers) && React.createElement(CardSubTitle, null, React.createElement(NumberLabel, {
    decimals: 0,
    value: followers
  }), " seguidor", followers !== 1 && 'es'), tagline ? React.createElement(Tagline, {
    extraMargin: true
  }, tagline.length > 90 ? "".concat(tagline.slice(0, 87), "...") : tagline) : null));
};